class KadeysReveal {
  constructor() {
    this.items = document.querySelectorAll('.kk-reveal');

    if (!this.items.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      this.items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    this.items.forEach((item) => this.observer.observe(item));
  }
}

const initializeKadeysLuxury = () => new KadeysReveal();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeKadeysLuxury, { once: true });
} else {
  initializeKadeysLuxury();
}

document.addEventListener('shopify:section:load', initializeKadeysLuxury);

const initializeKadeysProducts = (scope = document) => {
  scope.querySelectorAll('[data-kadeys-product]').forEach((productSection) => {
    if (productSection.dataset.productInitialized === 'true') return;

    const variantSelect = productSection.querySelector('[data-product-variant]');
    if (!variantSelect) return;

    const price = productSection.querySelector('[data-product-price]');
    const submit = productSection.querySelector('[data-product-submit]');
    const submitLabel = productSection.querySelector('[data-product-submit-label]');

    variantSelect.addEventListener('change', () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      const available = option.dataset.available === 'true';

      if (price) price.textContent = option.dataset.price;
      if (submit) {
        submit.disabled = !available;
        submit.setAttribute('aria-disabled', String(!available));
      }
      if (submitLabel) submitLabel.textContent = available ? 'Add to cart' : 'Sold out';
    });

    productSection.dataset.productInitialized = 'true';
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeKadeysProducts(), { once: true });
} else {
  initializeKadeysProducts();
}

document.addEventListener('shopify:section:load', (event) => initializeKadeysProducts(event.target));
